const jobplatforms = {
    "wh": "Web (All)",
    // "wn": '-- News',
    // "wf": '-- Forums',
    // "wb": '-- Blogs',
    "nfo": 'Social search',
    "nftw": 'X Search',
    "nftc": 'X Channel',
    "nf": 'Facebook Search',
    "nc": 'Facebook Channel',
    "ig": 'Instagram Search',
    "ic": 'Instagram Channel',
    "tt": 'TikTok Search',
    "tc": "TikTok Channel",
    "in": 'Linkedin Search',
    "inm": 'Linkedin Member',
    "tg": 'Telegram Search (limited)',
    "tgc": 'Telegram Channel (limited)',
    "bsky": 'Bluesky Search (limited)',
    // "rd": 'Reddit',
    // "yt": 'Youtube',
};
const getJobPlatformLabel = (id) => {
    const label = jobplatforms[id];
    return label ? label.replace("--","").trim() : id
}
export default jobplatforms;
export {getJobPlatformLabel};